import { defineComponent, h } from 'vue';

export const AuthIllustration = defineComponent({
  setup() {
    return function render() {
      return h('div', [
        h('img', {
          attrs: {
            src: '/images/signup 1.svg',
            class: 'auth-illustrations__illustration auth-illustrations__illustration--1',
          },
        }),
        h('img', {
          attrs: {
            src: '/images/signup 2.svg',
            class: 'auth-illustrations__illustration auth-illustrations__illustration--2',
          },
        }),
      ]);
    };
  },
});
